<label (click)="onActiveClick()" class="{{toggleStyle}}" [ngClass]="{'disabled':disabled,'readonly':readonly}">
  <div class="round" [ngClass]="{'active':active}"></div>
  <div class="content"><ng-content></ng-content></div>
</label>
